import { render, staticRenderFns } from "./inventoryProfitLoss.vue?vue&type=template&id=e5798430&scoped=true"
import script from "./inventoryProfitLoss.vue?vue&type=script&lang=js"
export * from "./inventoryProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./inventoryProfitLoss.vue?vue&type=style&index=0&id=e5798430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5798430",
  null
  
)

export default component.exports